import { render, staticRenderFns } from "./MediumComAdd.vue?vue&type=template&id=25120af9"
import script from "./MediumComAdd.vue?vue&type=script&lang=js"
export * from "./MediumComAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports